// src/app/app.module.ts
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { OpenObserveErrorHandler } from './core/telemetry/openobserve-error-handler';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './layouts/layout.module';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { FormsModule } from '@angular/forms';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HeadersInterceptor } from './core/interceptors/headers.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { MediaCdnInterceptor } from './core/interceptors/media-cdn.interceptor';
import { environment } from '../environments/environment';

export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LayoutModule,
    SharedModule,
    BrowserAnimationsModule,
    FormsModule,
    NgxDaterangepickerMd.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // Registered AFTER ErrorInterceptor so it catches a 401 first (response handlers
    // run bottom-up) and can refresh the token before ErrorInterceptor redirects.
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // Registered LAST so it sees the response FIRST (response handlers run
    // bottom-up): media URLs are rewritten closest to the network, before any
    // other interceptor or caller reads the body. Inert unless configured.
    { provide: HTTP_INTERCEPTORS, useClass: MediaCdnInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    ...(environment.openobserve?.enabled
      ? [
          {
            provide: ErrorHandler,
            useClass: OpenObserveErrorHandler
          }
        ]
      : [])
  ]
})
export class AppModule {}
